import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "fixed-header" }
const _hoisted_2 = { class: "flex items-center justify-center pt-16 mb-4" }
const _hoisted_3 = ["src"]
const _hoisted_4 = {
  key: 0,
  class: "flex items-center justify-center mb-6 px-5"
}
const _hoisted_5 = { class: "text-base2 text-white" }
const _hoisted_6 = { key: 0 }
const _hoisted_7 = {
  key: 1,
  class: "search-container"
}
const _hoisted_8 = { class: "content-container" }
const _hoisted_9 = { key: 0 }
const _hoisted_10 = {
  key: 0,
  class: "activities-list"
}
const _hoisted_11 = ["onClick"]
const _hoisted_12 = { class: "card-image-container" }
const _hoisted_13 = ["src", "alt"]
const _hoisted_14 = { class: "card-content" }
const _hoisted_15 = { class: "card-title" }
const _hoisted_16 = {
  key: 0,
  class: "card-subtitle"
}
const _hoisted_17 = ["innerHTML"]
const _hoisted_18 = {
  key: 2,
  class: "card-subtitle"
}
const _hoisted_19 = {
  key: 3,
  class: "activity-count"
}
const _hoisted_20 = {
  key: 1,
  class: "loading-state"
}
const _hoisted_21 = {
  key: 2,
  class: "empty-state"
}
const _hoisted_22 = { class: "empty-title" }
const _hoisted_23 = { class: "empty-subtitle" }
const _hoisted_24 = { key: 1 }
const _hoisted_25 = {
  key: 0,
  class: "activities-list"
}
const _hoisted_26 = ["onClick"]
const _hoisted_27 = { class: "queue-card-content" }
const _hoisted_28 = { class: "queue-header" }
const _hoisted_29 = { class: "queue-title" }
const _hoisted_30 = { class: "queue-position" }
const _hoisted_31 = { class: "queue-info" }
const _hoisted_32 = { class: "queue-status" }
const _hoisted_33 = {
  key: 0,
  class: "queue-date"
}
const _hoisted_34 = { key: 0 }
const _hoisted_35 = {
  key: 1,
  class: "loading-state"
}
const _hoisted_36 = {
  key: 2,
  class: "empty-state"
}
const _hoisted_37 = { class: "empty-title" }
const _hoisted_38 = { class: "empty-subtitle" }

import { ref, computed } from 'vue';
import {
	IonContent,
	IonButton,
	IonFooter,
	IonIcon,
	IonInfiniteScroll,
	IonInfiniteScrollContent,
	IonSearchbar,
	IonSpinner,
	InfiniteScrollCustomEvent,
	IonRefresher,
	IonRefresherContent,
	RefresherCustomEvent,
} from '@ionic/vue';
import {
	search,
	chevronBack
} from 'ionicons/icons';
import { useI18n } from 'vue-i18n';
import { useRouter } from 'vue-router';

import NavigationBar from '@/shared/components/ui/NavigationBar.vue';
import useQueue from '@/modules/queue/composables/useQueue';
import { useAssetsStore } from '@/stores/shared/assetsStore';
import { useCacheImage } from '@/shared/composables/useCacheImage';
import { useAuthStore } from '@/stores/auth/authStore';

// Init

export default /*@__PURE__*/_defineComponent({
  __name: 'QueueActivitiesPage',
  setup(__props) {

const { t } = useI18n();
const router = useRouter();
const queueSearch = ref('');
const activeTab = ref<'activities' | 'my-queues'>('activities');
const assetStore = useAssetsStore();
const authStore = useAuthStore();
const { loadImage } = useCacheImage();
const logoUrl = ref(assetStore.logoUrl);

// Load logo
if (assetStore.logoUrl) {
	let logoImage = assetStore.logoUrl.split('/').pop();
	logoImage = logoImage ?? 'logo';
	loadImage('logo', logoImage, assetStore.logoUrl).then(url => logoUrl.value = url);
}

// Queue composable
const { getQueueActivities, getMyQueues } = useQueue();
const { activities, fetchNextPage, hasNextPage, isFetchingActivitiesDataRequests, refetchActivitiesDataRequests } =
	getQueueActivities(queueSearch);
const { myQueues, isFetchingMyQueues, refetchMyQueues } = getMyQueues();

// Computed queue count
const myQueuesCount = computed(() => myQueues.value?.length || 0);

// Infinite scroll
const ionInfinite = async (ev: InfiniteScrollCustomEvent) => {
	if (hasNextPage && hasNextPage.value) {
		await fetchNextPage();
	}
	ev.target.complete();
};

// Pull to refresh
const handleRefresh = async (event: RefresherCustomEvent) => {
	if (activeTab.value === 'activities') {
		await refetchActivitiesDataRequests();
	} else {
		await refetchMyQueues();
	}
	event.target.complete();
};

// Navigate to category activities
const goToCategory = (categoryId: number, categoryName: string) => {
	router.push({
		name: 'queue-category-activities',
		params: { categoryId, categoryName }
	});
};

// Navigate to queue ticket detail
const goToQueueTicket = (queueSlotId: number) => {
	router.push(`/my-queues/${queueSlotId}`);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_unref(IonContent), { class: "queue-activities-page" }, {
      default: _withCtx(() => [
        _createVNode(_unref(IonRefresher), {
          slot: "fixed",
          onIonRefresh: _cache[0] || (_cache[0] = ($event: any) => (handleRefresh($event)))
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(IonRefresherContent))
          ]),
          _: 1
        }),
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("img", {
              src: logoUrl.value,
              class: "max-w-[180px]"
            }, null, 8, _hoisted_3)
          ]),
          (_unref(authStore).isAuthenticated())
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                _createVNode(_unref(IonButton), {
                  class: _normalizeClass(["mr-2 w-[140px] h-[40px] button-solid rounded-full", activeTab.value === 'activities' ? 'hover:bg-white' : 'backdrop-blur bg-white/20']),
                  shape: "round",
                  fill: activeTab.value === 'activities' ? 'default' : 'clear',
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (activeTab.value = 'activities'))
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("span", {
                      class: _normalizeClass(["text-base2", activeTab.value === 'activities' ? '' : 'text-white'])
                    }, _toDisplayString(_unref(t)('queue.activities')), 3)
                  ]),
                  _: 1
                }, 8, ["class", "fill"]),
                _createVNode(_unref(IonButton), {
                  class: "w-[140px] h-[40px] button-solid rounded-full backdrop-blur bg-white/20 hover:bg-white/20",
                  shape: "round",
                  fill: "clear",
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (_unref(router).push('/my-queues')))
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("span", _hoisted_5, [
                      _createTextVNode(_toDisplayString(_unref(t)('queue.my_queues')) + " ", 1),
                      (myQueuesCount.value > 0)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_6, " (" + _toDisplayString(myQueuesCount.value) + ")", 1))
                        : _createCommentVNode("", true)
                    ])
                  ]),
                  _: 1
                })
              ]))
            : _createCommentVNode("", true),
          (activeTab.value === 'activities')
            ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                _createVNode(_unref(IonSearchbar), {
                  modelValue: queueSearch.value,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((queueSearch).value = $event)),
                  placeholder: _unref(t)('queue.search_activities'),
                  class: "custom-searchbar",
                  debounce: 300,
                  "show-clear-button": "focus"
                }, null, 8, ["modelValue", "placeholder"])
              ]))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_8, [
          (activeTab.value === 'activities')
            ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                (_unref(activities) && _unref(activities).length > 0)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(activities), (category) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: category.id,
                          class: "activity-card",
                          onClick: ($event: any) => (goToCategory(category.id, category.name))
                        }, [
                          _createElementVNode("div", _hoisted_12, [
                            _createElementVNode("img", {
                              src: category.image_url || '/api/placeholder/400/240',
                              alt: category.name,
                              class: "card-image"
                            }, null, 8, _hoisted_13),
                            _cache[5] || (_cache[5] = _createElementVNode("div", { class: "card-gradient-overlay" }, null, -1)),
                            _createElementVNode("div", _hoisted_14, [
                              _createElementVNode("h3", _hoisted_15, _toDisplayString(category.name), 1),
                              (category.short_description)
                                ? (_openBlock(), _createElementBlock("p", _hoisted_16, _toDisplayString(category.short_description), 1))
                                : (category.description)
                                  ? (_openBlock(), _createElementBlock("div", {
                                      key: 1,
                                      class: "card-subtitle",
                                      innerHTML: category.description
                                    }, null, 8, _hoisted_17))
                                  : (_openBlock(), _createElementBlock("p", _hoisted_18, _toDisplayString(_unref(t)('queue.explore_activities')), 1)),
                              (category.sub_activities_count > 0)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_19, _toDisplayString(category.sub_activities_count) + " " + _toDisplayString(category.sub_activities_count === 1 ? 'activity' : 'activities'), 1))
                                : _createCommentVNode("", true)
                            ])
                          ])
                        ], 8, _hoisted_11))
                      }), 128))
                    ]))
                  : (_unref(isFetchingActivitiesDataRequests))
                    ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                        _createVNode(_unref(IonSpinner), { name: "circular" })
                      ]))
                    : (_openBlock(), _createElementBlock("div", _hoisted_21, [
                        _createVNode(_unref(IonIcon), {
                          icon: _unref(search),
                          class: "empty-icon"
                        }, null, 8, ["icon"]),
                        _createElementVNode("h3", _hoisted_22, _toDisplayString(queueSearch.value ? _unref(t)('queue.no_activities_found') : _unref(t)('queue.no_activities_available')), 1),
                        _createElementVNode("p", _hoisted_23, _toDisplayString(queueSearch.value ? _unref(t)('queue.try_different_search') : _unref(t)('queue.check_back_later')), 1)
                      ]))
              ]))
            : (activeTab.value === 'my-queues')
              ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                  (_unref(myQueues) && _unref(myQueues).length > 0)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(myQueues), (queue) => {
                          return (_openBlock(), _createElementBlock("div", {
                            key: queue.id,
                            class: "queue-card",
                            onClick: ($event: any) => (goToQueueTicket(queue.id))
                          }, [
                            _createElementVNode("div", _hoisted_27, [
                              _createElementVNode("div", _hoisted_28, [
                                _createElementVNode("h3", _hoisted_29, _toDisplayString(queue.queue_activity?.name || 'Queue Activity'), 1),
                                _createElementVNode("span", _hoisted_30, "#" + _toDisplayString(queue.position_number), 1)
                              ]),
                              _createElementVNode("div", _hoisted_31, [
                                _createElementVNode("p", _hoisted_32, _toDisplayString(_unref(t)(`queue.status_${queue.status}`)), 1),
                                (queue.booked_date)
                                  ? (_openBlock(), _createElementBlock("p", _hoisted_33, [
                                      _createTextVNode(_toDisplayString(new Date(queue.booked_date).toLocaleDateString()) + " ", 1),
                                      (queue.booked_time_slot)
                                        ? (_openBlock(), _createElementBlock("span", _hoisted_34, "• " + _toDisplayString(queue.booked_time_slot), 1))
                                        : _createCommentVNode("", true)
                                    ]))
                                  : _createCommentVNode("", true)
                              ])
                            ])
                          ], 8, _hoisted_26))
                        }), 128))
                      ]))
                    : (_unref(isFetchingMyQueues))
                      ? (_openBlock(), _createElementBlock("div", _hoisted_35, [
                          _createVNode(_unref(IonSpinner), { name: "circular" })
                        ]))
                      : (_openBlock(), _createElementBlock("div", _hoisted_36, [
                          _createVNode(_unref(IonIcon), {
                            icon: _unref(search),
                            class: "empty-icon"
                          }, null, 8, ["icon"]),
                          _createElementVNode("h3", _hoisted_37, _toDisplayString(_unref(t)('queue.no_queues_yet')), 1),
                          _createElementVNode("p", _hoisted_38, _toDisplayString(_unref(t)('queue.browse_activities_to_join')), 1),
                          _createVNode(_unref(IonButton), {
                            class: "mt-4",
                            onClick: _cache[4] || (_cache[4] = ($event: any) => (activeTab.value = 'activities'))
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_unref(t)('queue.browse_activities')), 1)
                            ]),
                            _: 1
                          })
                        ]))
                ]))
              : _createCommentVNode("", true)
        ]),
        _createVNode(_unref(IonInfiniteScroll), { onIonInfinite: ionInfinite }, {
          default: _withCtx(() => [
            _createVNode(_unref(IonInfiniteScrollContent))
          ]),
          _: 1
        }),
        _cache[6] || (_cache[6] = _createElementVNode("div", { class: "h-[100px]" }, " ", -1))
      ]),
      _: 1
    }),
    _createVNode(_unref(IonFooter), null, {
      default: _withCtx(() => [
        _createVNode(NavigationBar, { "item-active": "queue" })
      ]),
      _: 1
    })
  ], 64))
}
}

})